import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../SpriteMount.js";
var symbol = new SpriteSymbol({
  "id": "ridestyler-showcase-icon-rotate-vehicle",
  "use": "ridestyler-showcase-icon-rotate-vehicle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ridestyler-showcase-icon-rotate-vehicle\"><path d=\"M21.91 4.09a1 1 0 0 0-1.07.16l-1.36 1.21A9.81 9.81 0 0 0 12 2a10 10 0 1 0 9.42 13.33 1 1 0 0 0-1.89-.66A8 8 0 1 1 12 4a7.86 7.86 0 0 1 6 2.78l-1.66 1.47a1 1 0 0 0-.27 1.11A1 1 0 0 0 17 10h4.5a1 1 0 0 0 1-1V5a1 1 0 0 0-.59-.91z\" fill=\"#464646\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol